import Vue from 'vue';
import store from './store'
import App from './App.vue';
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';
import '../src/css/style.css';
import 'vue-material-design-icons/styles.css';
import i18n from './i18n'
import Vueditor from 'vueditor'
import 'vueditor/dist/style/vueditor.min.css'
Vue.config.productionTip = false

Vue.use(Antd);
Vue.use(Vueditor, { uploadUrl: './php/request.php?run=uploadImage' });
new Vue({
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')

